(function(root){'use strict';var designs=[
  {
    "id": "storybook-evergreens",
    "name": "Storybook Evergreens",
    "handle": "storybook-evergreens-illustrated-holiday-photo-card",
    "width": 700,
    "height": 500,
    "background": "#faf7ef",
    "accent": "#a5824b",
    "photos": [
      {
        "x": 108,
        "y": 108,
        "w": 484,
        "h": 269
      }
    ],
    "texts": [
      {
        "key": "greeting",
        "label": "Holiday greeting",
        "value": "Merry & Bright",
        "x": 350,
        "y": 427,
        "size": 43,
        "font": "serif",
        "color": "#26382f",
        "width": 470,
        "spacing": 0
      },
      {
        "key": "family",
        "label": "Family name",
        "value": "The Williams Family",
        "x": 350,
        "y": 463,
        "size": 23,
        "font": "serif",
        "color": "#26382f",
        "width": 430,
        "spacing": 0
      },
      {
        "key": "year",
        "label": "Year",
        "value": "2026",
        "x": 350,
        "y": 489,
        "size": 13,
        "font": "serif",
        "color": "#8d6d37",
        "width": 80,
        "spacing": 2
      }
    ],
    "description": "Send a little storybook magic. Hand-painted evergreen trees, fine garlands, and cranberry accents frame your favorite family photo in a warm ivory landscape card. Add one photo, crop it to fit, and personalize the greeting, family name, and year while the original illustration and fonts stay in place.",
    "seo": "Create a 5\u00d77 illustrated holiday photo card with painted evergreens, your family photo, and live text editing. Premium cardstock and envelopes included.",
    "artUrl": "https://ucarecdn.com/d7177cc0-6f6e-4ddb-800b-0a1da9f08210/",
    "artFile": "fp-holiday-art-storybook-evergreens.png",
    "decoration": "illustration"
  },
  {
    "id": "snowfall-village",
    "name": "Snowfall Village",
    "handle": "snowfall-village-illustrated-holiday-photo-card",
    "width": 500,
    "height": 700,
    "background": "#f3f6f3",
    "accent": "#b6904d",
    "photos": [
      {
        "x": 44,
        "y": 91,
        "w": 412,
        "h": 231
      }
    ],
    "texts": [
      {
        "key": "greeting",
        "label": "Holiday greeting",
        "value": "Happy Holidays",
        "x": 250,
        "y": 65,
        "size": 60,
        "font": "script",
        "color": "#ffffff",
        "width": 420,
        "spacing": 0
      },
      {
        "key": "family",
        "label": "Family name",
        "value": "The Macallan Family",
        "x": 250,
        "y": 658,
        "size": 24,
        "font": "serif",
        "color": "#26382f",
        "width": 410,
        "spacing": 0
      },
      {
        "key": "year",
        "label": "Year",
        "value": "2026",
        "x": 250,
        "y": 685,
        "size": 15,
        "font": "serif",
        "color": "#547c79",
        "width": 80,
        "spacing": 2
      }
    ],
    "description": "Your favorite faces, tucked into a winter story. A softly painted village of snowy rooftops, glowing windows, evergreens, and a little red truck turns one family photo into a warm seasonal greeting. Upload your photo and edit the holiday greeting, family signature, and year in the live preview.",
    "seo": "Personalize a 5\u00d77 watercolor winter village holiday card with your family photo and custom greeting. Live text editing, cardstock, and envelopes included.",
    "artUrl": "https://ucarecdn.com/4ced14eb-5177-49d8-a8f8-3dfe8d2054fe/",
    "artFile": "fp-holiday-art-snowfall-village.png",
    "decoration": "illustration"
  },
  {
    "id": "festive-paws",
    "name": "Festive Paws",
    "handle": "festive-paws-illustrated-pet-holiday-photo-card",
    "width": 500,
    "height": 700,
    "background": "#26382f",
    "accent": "#b6904d",
    "artLayer": "foreground",
    "artBox": {
      "x": 0,
      "y": 0,
      "w": 500,
      "h": 615
    },
    "textScrim": true,
    "photos": [
      {
        "x": 0,
        "y": 0,
        "w": 500,
        "h": 700
      }
    ],
    "sample": "fp-hero-memory-dog-2026.jpg",
    "texts": [
      {
        "key": "greeting",
        "label": "Holiday greeting",
        "value": "Paw-la-la-la-la",
        "x": 250,
        "y": 650,
        "size": 46,
        "font": "script",
        "color": "#ffffff",
        "width": 430,
        "spacing": 0
      },
      {
        "key": "family",
        "label": "Names",
        "value": "The Thompsons & Teddy",
        "x": 250,
        "y": 680,
        "size": 21,
        "font": "serif",
        "color": "#ffffff",
        "width": 420,
        "spacing": 0
      }
    ],
    "description": "Put your most photogenic family member on the holiday mailing list. A full-card pet portrait sits behind a sweeping garland of richly painted ornaments, including a playful cat-shaped bauble. Add a favorite dog, cat, or family photo, then edit the greeting and names. The ornament artwork stays beautifully arranged in the live preview.",
    "seo": "Make a 5\u00d77 custom pet holiday photo card with illustrated ornaments, your dog or cat photo, and editable text. Premium cardstock and envelopes included.",
    "artUrl": "https://ucarecdn.com/aac50872-5067-49c4-8c02-86340a0fe16d/",
    "artFile": "fp-holiday-art-festive-paws.png",
    "decoration": "illustration"
  },
  {
    "id": "purrfect-holiday",
    "name": "Purrfect Holiday",
    "handle": "purrfect-holiday-illustrated-cat-photo-card",
    "width": 500,
    "height": 700,
    "background": "#f7efda",
    "accent": "#b6904d",
    "photos": [
      {
        "x": 90,
        "y": 36,
        "w": 320,
        "h": 320,
        "shape": "circle"
      }
    ],
    "sample": "fp-roll-cat.jpg",
    "texts": [
      {
        "key": "greeting",
        "label": "Holiday greeting",
        "value": "Wrapped in holiday cheer",
        "x": 250,
        "y": 604,
        "size": 37,
        "font": "serif",
        "color": "#26382f",
        "width": 432,
        "spacing": 0
      },
      {
        "key": "family",
        "label": "Names",
        "value": "From Naila & Mister Mittens",
        "x": 250,
        "y": 647,
        "size": 23,
        "font": "serif",
        "color": "#26382f",
        "width": 420,
        "spacing": 0
      },
      {
        "key": "year",
        "label": "Year",
        "value": "2026",
        "x": 250,
        "y": 680,
        "size": 15,
        "font": "serif",
        "color": "#8a6537",
        "width": 80,
        "spacing": 2
      }
    ],
    "description": "A little mischief. A lot of holiday love. A hand-painted calico cat tangled in festive lights rests beneath your circular photo, set against warm parchment cream. Add a pet portrait, a selfie together, or a favorite family moment. Make the greeting, signature, and year your own with fixed-font live text editing.",
    "seo": "Create a 5\u00d77 illustrated cat holiday photo card with a circular photo and playful festive lights. Personalize text live. Cardstock and envelopes included.",
    "artUrl": "https://ucarecdn.com/365dc36a-8f42-46d4-91b7-fd377991a204/",
    "artFile": "fp-holiday-art-purrfect-holiday.png",
    "decoration": "illustration"
  }
];root.FoxPrintHolidayDesigns=designs;if(typeof module!=='undefined'&&module.exports)module.exports=designs;}(typeof window!=='undefined'?window:globalThis));
